var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5301 20.9026C19.5096 21.2829 20.5481 20.4966 20.4259 19.4644L20.0328 16.1441L20.2299 15.9182C21.3827 14.5497 22 12.9386 22 11.2366C22 6.63876 17.492 3 12 3C6.50801 3 2 6.63876 2 11.2366C2 15.8345 6.50801 19.4733 12 19.4733C12.7105 19.4733 13.4502 19.4017 14.2876 19.2557L18.5301 20.9026ZM18.3142 15.1817L18.0821 15.4168L18.5094 19L14.2928 17.375L14.0935 17.4117C13.3026 17.5573 12.6308 17.6271 12 17.6271C7.55529 17.6271 4 14.778 4 11.3135C4 7.84912 7.55529 5 12 5C16.4447 5 20 7.84912 20 11.3135C20 12.728 19.4182 14.0632 18.3142 15.1817ZM8.87066 10.608C8.36837 10.608 7.96092 10.2068 7.96092 9.71172C7.96092 9.21659 8.36837 8.81547 8.87066 8.81547H15.1293C15.6316 8.81547 16.0391 9.21659 16.0391 9.71172C16.0391 10.2068 15.6316 10.608 15.1293 10.608H8.87066ZM7.96092 12.7616C7.96092 13.2567 8.36837 13.6578 8.87066 13.6578H12.7823C13.2846 13.6578 13.6921 13.2567 13.6921 12.7616C13.6921 12.2664 13.2846 11.8653 12.7823 11.8653H8.87066C8.36837 11.8653 7.96092 12.2664 7.96092 12.7616Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.6032ee4b.svg";
export { ForwardRef as ReactComponent };